/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundFaxPaginationDto
 */
export interface InboundFaxPaginationDto {
    /**
     * 
     * @type {number}
     * @memberof InboundFaxPaginationDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InboundFaxPaginationDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof InboundFaxPaginationDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof InboundFaxPaginationDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the InboundFaxPaginationDto interface.
 */
export function instanceOfInboundFaxPaginationDto(value: object): value is InboundFaxPaginationDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function InboundFaxPaginationDtoFromJSON(json: any): InboundFaxPaginationDto {
    return InboundFaxPaginationDtoFromJSONTyped(json, false);
}

export function InboundFaxPaginationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundFaxPaginationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
        'totalPages': json['totalPages'],
    };
}

export function InboundFaxPaginationDtoToJSON(json: any): InboundFaxPaginationDto {
    return InboundFaxPaginationDtoToJSONTyped(json, false);
}

export function InboundFaxPaginationDtoToJSONTyped(value?: InboundFaxPaginationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'totalPages': value['totalPages'],
    };
}

